export default __webpack_public_path__ + "static/media/microsoft-logo.e2ecfee7.svg";